module.exports = __webpack_public_path__ + "img/22.d3c78f5b.jpg";